// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner__Loader__[hash_base64-5]","load6":"Spinner__load6__[hash_base64-5]","round":"Spinner__round__[hash_base64-5]"};